module.exports = __webpack_public_path__ + "static/unit_02_icon-6aae24313afe8d1a7135110d72fc087e.svg";